import type { ComponentProps } from 'react';
import { EntityPeek, cn } from '@/components/ui';
import { EntityChipIcon } from '@/components/ui/entityIcons';
import { ObjectLink } from './ObjectLink';

/*
  EntityLink — живое имя, которое ещё и открывает объект: по наведению карточка состояния (R26),
  по клику — вкладка (R37), с Ctrl — на фоне, с Shift — рядом. Вид — как у EntityPeek: пунктир
  снизу и значок типа.
*/

type EntityLinkProps = Omit<ComponentProps<typeof EntityPeek>, 'children'> & { to: string };

export function EntityLink({ to, kind, name, className, ...peek }: EntityLinkProps) {
  return (
    <EntityPeek kind={kind} name={name} {...peek}>
      <ObjectLink
        to={to}
        className={cn(
          'inline-flex items-center gap-1 rounded-xs align-baseline font-medium text-fg',
          'underline decoration-line-strong decoration-dotted underline-offset-4',
          'transition-colors duration-fast hover:decoration-brand focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none',
          className,
        )}
      >
        <EntityChipIcon kind={kind} className="size-3.5 shrink-0 text-fg-subtle" />
        {name}
      </ObjectLink>
    </EntityPeek>
  );
}
